import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { environment } from "../../environments/environment";
import { take } from 'rxjs/operators';
import { LogService } from 'src/app/services/log.service'
import { OnReset, Transitions } from './transition.service.helpers';
import { takeUntil, tap } from 'rxjs/operators';
import { lastValueFrom, Subject } from 'rxjs';
//import 'firebase/firestore';
import { Store, select } from '@ngrx/store';
import { InformableSection, Informable, InformableType } from 'globals/store/informables.data';
import { addDoc, collection, collectionChanges, collectionData, collectionSnapshots, doc, docSnapshots, DocumentChange, DocumentData, FieldValue, Firestore, query, QueryDocumentSnapshot, serverTimestamp, updateDoc, where } from '@angular/fire/firestore';
import { informableActions, informableFeature } from '../store/informables.era';


@Injectable({ providedIn: 'root' })
export class InformablesService implements OnReset {

  readonly api = `${environment.functionsURL}api/app`;
  readonly _file = 'informables.service.ts'
  public $destroy_selected_event: Subject<boolean> = new Subject();
  public eventId
  private initialEventLoaded = false;

  onReset(resetType, value = null) {
    switch (resetType) {
      case Transitions.OnEnterEvent:
        // console.log('subscribing to informables...')
        return this.getInformablesForEvent(value.eventId)
      case Transitions.OnExitUser:
        // no break needed at the moment
      case Transitions.OnExitEvent:
        this.$destroy_selected_event.next(true)
        break
      default:
        break;
    }

  }

  constructor(
    private http:HttpClient,
    private log:LogService,
    private db: Firestore,
    public store: Store,
  ){ }

  getInformablesForEvent(eventId){
    this.eventId = eventId;
    this.initialEventLoaded = false;// snapshotChanges
    collectionData(query(collection(this.db, 'informables'), where('eventId', '==', eventId)), { idField: 'id' }).pipe(
      take(1)
    ).subscribe(data=>{
      // handle initial data if no records exist
      if((!data || !data.length) && !this.initialEventLoaded){
        this.initialEventLoaded = true;
        this.store.dispatch(informableActions.loadDefaults(eventId))
      }
    });

    collectionChanges(query(collection(this.db, 'informables'), where('eventId', '==', eventId))).pipe(
      tap((changes: DocumentChange<DocumentData>[]) => this.handleInformableChangesFromDB(changes),
        error=> this.log.error({file:this._file, function:'getInformablesForEvent',response:error,error:new Error()})),
      takeUntil(this.$destroy_selected_event)
    ).subscribe(changes=>{
      if(!this.initialEventLoaded){
        this.initialEventLoaded = true;
        this.store.dispatch(informableActions.loadDefaults(eventId))
      }
    })
  }

  handleInformableChangesFromDB(informables:DocumentChange<DocumentData>[]){
    informables.forEach((change:DocumentChange<Informable>)=>{
      const informable = change.doc.data()
      // if (informable.type === 'event') console.log({ informable })
      informable.id = change.doc.id
      if(change.type === 'removed') {
        this.store.dispatch(informableActions.removeInformable(informable.type, informable.id))
        return
      }
      this.store.dispatch(informableActions.loadInformable(informable))
    })
  }

  async checkIfEntityDefaultsAreNeeded(entityType: InformableType, eventId:string, entityId:string){
    const selector: keyof typeof informableFeature = entityType === 'performer' ? "selectPerformers" : entityType === 'exhibitor' ? 'selectExhibitors' : entityType === 'resource' ? 'selectResources' : entityType === 'attendee' ? 'selectAttendees' : null
    const informables = await lastValueFrom(this.store.pipe(select(informableFeature[selector]), take(1)))
    // console.log({ informable })
    const informable = informables ? informables[entityId] : null
    if (!informable) this.store.dispatch( informableActions.addDefaultEntityInfo(entityType, eventId, entityId ))
  }

  
  copyItemName(name, sections:InformableSection){ // check for previous copies and adjust titles - if first copy, just add copy of to the front
    const siblings = sections.items;
    const title_base:string = name.replace(/^Copy (of|\d+) /,'');
    let highest = 0;
    siblings.forEach(sibling=>{
        const sibling_title_base = sibling.name.replace(/^Copy (of|\d+) /,'');
        if(sibling_title_base === title_base){
            const p = sibling.name.split(' ');
            if(p[1] === 'of' && highest < 2){
                highest = 1;
            }else if(/\d/.test(p[1]) && highest < parseInt(p[1], 10) ){
                highest = parseInt(p[1], 10);
            }
        }
    })
    switch(highest){
        case 0:
            name = 'Copy of ' + title_base;
            break;
        default:
            name = 'Copy '+ (highest + 1) + ' ' + title_base
    }
    return name;
  }

  async saveInformation(informableId:string, info:InformableSection[], type: InformableType, informableKey?:string){
    console.log({ informableId, info, type, informableKey })
    if(!informableId){ // for informables temporarily created for default values
      await this.createInformable({ type, info }, informableKey)
      return;
    }
    await updateDoc(doc(this.db, '/informables/'+informableId), {info})
  }

  async createInformable(informable:Partial<Informable>, informableKey?:string) {
    let existing_informable = informable;
    if (informableKey) {
      const selector: keyof typeof informableFeature = informable.type === 'performer' ? "selectPerformers" : informable.type === 'exhibitor' ? 'selectExhibitors' : informable.type === 'resource' ? 'selectResources' : informable.type === 'attendee' ? 'selectAttendees' : null
      
      const existing: Partial<Informable> = await lastValueFrom(this.store.select(informableFeature[selector], informableKey).pipe(take(1)))
      if (existing) existing_informable = existing
    }
    const insertObject:Informable = Object.assign({
      type:'event', // event by default
      info:[],
      eventId: this.eventId,
      timestamp: serverTimestamp()
    }, existing_informable, informable)
    insertObject.eventId = this.eventId
    await addDoc(collection(this.db, '/informables/'), insertObject)
  }
}
